
// DO NOT EDIT. This is a generated file.
// tslint:disable

export const BUILD_INFO = {
  "name": "admin-ui",
  "version": "1.27.1",
  "date": "2026-10-06T06:27:01.219Z",
  "branch": null,
  "rev": "bf6f56c6b9",
  "tag": null,
  "commitsSinceLastTag": null,
  "authorDate": null,
  "buildNumber": null
};
